import {
  applyPreloadedNativeStorageSnapshot,
  notifyStorageClear,
  notifyStorageRemove,
  notifyStorageSet,
} from 'utils/webviewBridge';

applyPreloadedNativeStorageSnapshot();

export const saveToStorage = (
  key: string,
  value: string,
  session?: boolean
) => {
  const storageValue = String(value);

  if (session) {
    sessionStorage.setItem(key, storageValue);
    notifyStorageSet('sessionStorage', key, storageValue);
  } else {
    localStorage.setItem(key, storageValue);
    notifyStorageSet('localStorage', key, storageValue);
  }
};

export const fetchFromStorage = (key: string, session?: boolean) => {
  if (session) {
    return sessionStorage.getItem(key);
  } else {
    return localStorage.getItem(key);
  }
};

export const removeFromStorage = (key: string, session?: boolean) => {
  if (session) {
    sessionStorage.removeItem(key);
    notifyStorageRemove('sessionStorage', key);
  } else {
    localStorage.removeItem(key);
    notifyStorageRemove('localStorage', key);
  }
};

export const clearStorage = (level: "session" | "local" | "all" = "local") => {
  switch (level) {
    case "session":
      sessionStorage.clear();
      notifyStorageClear('sessionStorage');
      break;
    case "local":
      localStorage.clear();
      notifyStorageClear('localStorage');
      break;
    case "all":
      sessionStorage.clear();
      localStorage.clear();
      notifyStorageClear('all');
      break;
  }
};
